import { render, staticRenderFns } from "./AllCustomersTable.vue?vue&type=template&id=068e4e15&scoped=true&"
import script from "./AllCustomersTable.vue?vue&type=script&lang=ts&"
export * from "./AllCustomersTable.vue?vue&type=script&lang=ts&"
import style0 from "./AllCustomersTable.vue?vue&type=style&index=0&id=068e4e15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068e4e15",
  null
  
)

export default component.exports